import { useContextEffect, useStableCallback } from './useBetterHooks';
import { TIMER_STATUS, useTimer } from './useTimer';

export function useCountdownTimer({
  initialTime = 0, // in seconds
  autostart = false,
  resetOnExpire = false,
  onExpire,
  onTick
}) {
  const onTimeOver = useStableCallback(() => {
    if (onExpire && typeof onExpire === 'function') {
      onExpire();
    }
    if (resetOnExpire) {
      reset(initialTime);
    }
  });

  const onTimeUpdate = useStableCallback((time) => {
    if (status === TIMER_STATUS.RUNNING && onTick && typeof onTick === 'function') {
      onTick(time);
    }
  });

  const { time, start, pause, reset, status } = useTimer({
    autostart,
    initialTime,
    endTime: 0,
    timerType: 'DECREMENTAL',
    onTimeOver,
    onTimeUpdate
  });

  useContextEffect({
    deps: [],
    ctx: { reset, status },
    cb: (ctx) => {
      // Cleanup function to stop the timer when the component unmounts
      if (ctx.status === TIMER_STATUS.RUNNING) {
        ctx.reset();
      }
    }
  });

  return {
    countdown: time,
    isRunning: status === TIMER_STATUS.RUNNING,
    start,
    reset,
    pause
  };
}
